//@flow
import React from 'react';
import classnames from 'classnames';
import theme from './FpTimelineScale.scss';
import moment from 'moment-timezone';
import { themr } from 'react-css-themr';
import { Position } from '@locus-taxy/neo-ui';

type Props = {
    visibleTimeStart: number,
    visibleTimeEnd: number,
    scale: number,
    scaleFactor: number,
    width: number
};
class FpScaleLines extends React.PureComponent<Props, void> {
    constructor(props) {
        super(props);
        this.state = {
            currentTime: moment().second(0).millisecond(0)
        };
    }

    renderScaleLines() {
        const {
            visibleTimeStart,
            visibleTimeEnd,
            scale,
            height,
            width,
            scaleFactor,
            showCurrentTimeIndicator,
            theme
        } = this.props;
        const scaleLines = [];
        const scaleWidth = 60 * scale;
        const effectiveScale = scale * (1 / scaleFactor);
        const currentTime = moment().second(0).millisecond(0).valueOf();
        let timePoint = moment(visibleTimeStart)
            .minute(0)
            .second(0)
            .millisecond(0);
        let timePointValue = timePoint.valueOf();

        if (
            visibleTimeEnd >= currentTime &&
            currentTime >= visibleTimeStart &&
            showCurrentTimeIndicator
        ) {
            const currentPx = (currentTime - visibleTimeStart) / effectiveScale;
            scaleLines.push(
                <Position
                    key={'current-time-scale-line'}
                    className={classnames(theme.line, theme.current)}
                    sx={{
                        width: '1px',
                        position: 'absolute',
                        left: currentPx,
                        height,
                        background: '#70B3FF'
                    }}
                />
            );
        }

        let px = 0;
        let centerPx = 0;
        while (timePointValue <= visibleTimeEnd || centerPx < width) {
            px = (timePointValue - visibleTimeStart) / effectiveScale;
            centerPx =
                ((timePointValue + scaleWidth - visibleTimeStart) /
                    effectiveScale +
                    px) /
                2;
            scaleLines.push(
                <div
                    className={classnames(theme.line, theme.mid, {
                        [theme.firstVisibleLine]: px === 0
                    })}
                    key={timePointValue}
                    style={{
                        width: '1px',
                        position: 'absolute',
                        left: px,
                        height
                    }}
                />
            );
            scaleLines.push(
                <div
                    className={classnames(theme.line, {
                        [theme.firstVisibleLine]: centerPx === 0
                    })}
                    key={`${timePointValue}-mid`}
                    style={{
                        width: '1px',
                        position: 'absolute',
                        left: centerPx,
                        height
                    }}
                />
            );
            timePoint = moment(timePointValue + scaleWidth);
            timePointValue = timePoint.valueOf();
        }
        return scaleLines;
    }
    render() {
        const { theme } = this.props;
        return (
            <div className={theme.scaleLines}>{this.renderScaleLines()}</div>
        );
    }
}

export default themr('FpScaleLines', theme)(FpScaleLines);
